import * as React from "react";
import type { SVGProps } from "react";
const SvgWarningHardFilled = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" {...props}>
        <path
            fill="currentcolor"
            fillRule="evenodd"
            d="M12.872 3.51a1 1 0 0 0-1.744 0l-9 16A1 1 0 0 0 3 21h18a1 1 0 0 0 .872-1.49zM12 15a1 1 0 0 1-1-1v-3a1 1 0 1 1 2 0v3a1 1 0 0 1-1 1m-1 2a1 1 0 1 1 2 0 1 1 0 0 1-2 0"
            clipRule="evenodd"
        />
    </svg>
);
export default SvgWarningHardFilled;
